export enum ChatDialogActionType {
  EditChat = 'Edit chat',
  PlaceBack = 'Place back',
  Transfer = 'Transfer chat',
  DeleteChat = 'Delete chat',
  AddMembers = 'Add members',
  CompleteChat = 'Complete chat',
}
